// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fLmZ","buttons":"styles_buttons__2vtP-"};